export default __webpack_public_path__ + "static/media/tiktok.fa6b8a6d.png";